import { useQuery } from 'react-query';
import request from '../../../../helpers/request';

export const createKey = (params = {}) => [
  'paymentTypes',
  Object.values(params),
];

const paymentTypesQuery = async ({ requestId }) => {
  return request.get(
    `/Request/payment_types/${requestId}`,
    {},
    `При загрузке способов оплаты произошла ошибка`,
    'Error'
  );
};

export const usePaymentTypes = (params, options) =>
  useQuery(createKey(params), () => paymentTypesQuery(params), options);
